import { mapGetters } from "vuex";
import _ from "lodash";
import CryptoJS from "crypto-js";

export default {
  computed: {
    ...mapGetters(["getNavigation"]),
  },
  methods: {
    handleView(val, newtab) {
      if (val.rest_api === "pi") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "PiManifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "PiManifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "po") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "PoManifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "PoManifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "um_pp") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "UmppManifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "UmppManifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "wo") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestWO",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifestWO",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "pp") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestPp",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifestPp",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "supplier") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestPurchasing",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifestPurchasing",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "sppds" || val.rest_api ==='sppds/sppdsDetil') {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "um_pd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "umpd_manifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "umpd_manifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "lap_um_pp") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "lapUmppManifest",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "lapUmppManifest",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "klaim_biaya_pd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestKlaimPd",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifestKlaimPd",
              params: {
                id: val.id_manifest,
                tlc: this.getAuth.username,
                user_pembuat: val.user_pembuat,
              },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "lap_um_pd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestLaporanUmpd",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "manifestLaporanUmpd",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
        }
      } else if (val.rest_api === "lap_kegiatan_pd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestLapPD",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "manifestLapPD",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
        }
      } else if (val.rest_api === "kas_kecil") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestLaporanKasKecil",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router
            .push({
              name: "manifestLaporanKasKecil",
              params: { id: val.id_manifest, tlc: val.tlc },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (val.rest_api === "sales_notification") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestSalesNotification",
            params: { id: val.id_manifest ? val.id_manifest : val.id, tlc: val.tlc, user_pembuat: val.user_pembuat ? val.user_pembuat : val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "manifestSalesNotification",
            params: { id: val.id_manifest ? val.id_manifest : val.id, tlc: val.tlc, user_pembuat: val.user_pembuat ? val.user_pembuat : val.tlc },
          });
        }
      } else if (val.rest_api === "adendum") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "AddendumManifest",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "AddendumManifest",
            params: { id: val.id_manifest, user_pembuat: val.tlc },
          });
        }
      } else if (val.rest_api === "klaim_pp") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestKlaimPp",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "manifestKlaimPp",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
        }
      } else if (val.rest_api === "accountpay") {
        console.log(val)
        if (newtab) {
          const route = this.$router.resolve({
            name: "account-pay-manifest",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
        }
      } else if (val.rest_api === "klaim_direktur") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestDirectur",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "manifestDirectur",
            params: {
              id: val.id_manifest,
              tlc: this.getAuth.username,
              user_pembuat: val.user_pembuat,
            },
          });
        }
      } else if (val.rest_api === "accountreceive" || val.rest_api ==="account_receivable_sales_contract") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "account-receive-manifest",
            params: { tab: val.tab,jns: val.jns,id: val.id_manifest,  },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "account-receive-manifest",
            params: { tab: val.tab,jns: val.jns,id: val.id_manifest,  },
          });
        }
      } else if (val.rest_api === "sales_contract") {
        this.$router.push({
          name: "manifestSalesContract",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "financing") {
        this.$router.push({
          name: "financing-manifest",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "account_mutation") {
        this.$router.push({
          name: "AccountMutationManifestKeu",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "bkm") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "bkmManifestKeu",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "bkmManifestKeu",
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "bkk" || val.rest_api === 'ukk') {
        if (newtab) {
          const route = this.$router.resolve({
            name: "bkkManifestKeu",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "bkkManifestKeu",
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "penarikan-financing") {
        this.$router.push({
          name: "penarikan-financing-manifest",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "bidbond_request") {
        if ("Vice President Marketing".toLowerCase() ==
          (val.sebagai ? val.sebagai.toLowerCase() : '')) {
          this.$router.push({
            name: "bidBondRequest-manifest",
            params: { id: val.id_manifest },
          });
        } else {
          this.$router.push({
            name: "bidBondRequest-manifest-mar",
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "bidbond") {
        this.$router.push({
          name: "bidBond-manifestKeu",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "piutang_karyawan") {
        this.$router.push({
          name: "piutangkaryawan-manifestKeu",
          params: { id: val.id_manifest },
        });
      
      } else if (val.rest_api === "pembayaran_piutang") {
        this.$router.push({
          name: "pembayaranpiutang-manifest-keu",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "pembayaran_piutang") {
        this.$router.push({
          name: "pembayaranpiutang-manifest-hrd",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "termin_release") {
        if ("Marketing".toLowerCase() ==
          (val.sebagai ? val.sebagai.toLowerCase() : '')) {
          this.$router.push({
            name: "terminReleaseManifestMar",
            params: { id: val.id_manifest },
          });
        } else {
          this.$router.push({
            name: "terminReleaseManifestKeu",
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "account_receivable") {
        if ("Keuangan".toLowerCase() ==
          (val.sebagai ? val.sebagai.toLowerCase() : '')) {
          if (newtab) {
            const route = this.$router.resolve({
              name: "account-receive-manifest",
              params: { tab: val.tab, jns: val.jenis, id: val.id_manifest, },
            });
            window.open(route.href, "_blank");
          } else {
            this.$router.push({
              name: "account-receive-manifest",
              params: { tab: val.tab, jns: val.jenis, id: val.id_manifest },
            });
          }
        } else {
          if (newtab) {
            const route = this.$router.resolve({
              name: "account-receive-manifest",
              params: { tab: val.tab, jns: val.jenis, id: val.id_manifest, },
            });
            window.open(route.href, "_blank");
          } else {
            this.$router.push({
              name: "account-receivable-manifest",
              params: { tab: val.tab, jns: val.jenis, id: val.id_manifest },
            });
          }
        }
      } else if (val.rest_api === "refund_payment") {
        this.$router.push({
            name: "RefundPaymentManifestKeu",
            params: { tab: val.tab, jns: val.jenis, id: val.id_manifest },
          });
      } else if (val.rest_api === "close_um") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "closingUMManifestKeu",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "closingUMManifestKeu",
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "account_pay") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "account-pay-manifest",
            params: { id: val.id_manifest, tlc: val.user_pembuat },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: val.id_manifest, tlc: val.user_pembuat },
          });
        }
      } else if (val.rest_api.toLowerCase() === "invoice") {
        console.log(val)
        if (newtab) {
          const route = this.$router.resolve({
            name: "invoice-manifest",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: "invoice-manifest",
            params: { id: val.id_manifest, tlc: val.tlc },
          });
        }
      } else if (val.rest_api === "pi_release") {
        this.$router.push({
          name: "ManifestPIRelease",
          params: { id: val.id_manifest, tlc: val.tlc },
        });
      } else if (val.rest_api === "rnd_notification") {
        this.$router.push({
          name: "manifestRNDNotification",
          params: { id: val.id_manifest, tlc: val.tlc },
        });
      } else if (val.rest_api === "other_income") {
        this.$router.push({
          name: "OtherIncomeManifestKeu",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "other_outcome") {
        this.$router.push({
          name: "OtherOutcomeManifestKeu",
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "/simfoni/plafon/annual" || val.rest_api === "/simfoni/plafon/monthly") {
        this.$router.push({
          name: val.sebagai=="Direktorat Finance" ? "MonthlyAnnualManifest_Vpf" : "MonthlyAnnualManifestDir",
          params: { 
            id: val.id_manifest,
            type: val.rest_api === "/simfoni/plafon/annual" ? "1" :
              (val.rest_api === "/simfoni/plafon/monthly" && !val.tipe.includes("Liability") ? "2" : "3")
          },
        });
      } else if (val.rest_api === "evaluasi_suplier") {
        this.$router.push({
          name: 'supplierEvaluation-manifest'+val.to,
          params: { id: val.id_manifest, tlc: val.tlc },
        });
      } else if (val.rest_api === "klaim_cc") {
        this.$router.push({
          name: 'manifestKlaimCC',
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "lap_bailout") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "bailoutfundreportManifest",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'bailoutfundreportManifest',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "prospek") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestProspectNotification",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'manifestProspectNotification',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "rekap_kesehatan") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "rekapKlaimKesehatanManifest",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'rekapKlaimKesehatanManifest',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "rekap_lkpd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "rekapLKPDManifest",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'rekapLKPDManifest',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "komponen_gaji") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "salary-component-manifest-dir",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'salary-component-manifest-dir',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "klaim_cc_pd") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "manifestCCKlaimPd",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'manifestCCKlaimPd',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "pp/recapitulationrelease") {
        if (newtab) {
          const route = this.$router.resolve({
            name: "ManifestRecapitulationRelease",
            params: { id: val.id_manifest },
          });
          window.open(route.href, "_blank");
        } else {
          this.$router.push({
            name: 'ManifestRecapitulationRelease',
            params: { id: val.id_manifest },
          });
        }
      } else if (val.rest_api === "pipeline") {
        this.$router.push({
          name: 'pipeline-manifest',
          params: { id: val.id_manifest || val.id },
        });
      } else if (val.rest_api === "liability") {
        this.$router.push({
          name: 'manifestAccountpaymonitoringFC',
          params: { id: val.id_manifest },
        });
      } else if (val.rest_api === "recapitulation") { 
        let names = "";
        if(val.no_manifest.includes('RKCCT')){
          names = "rekapKlaimTiketManifest";
        } else if(val.no_manifest.includes('RKS')){
          if (localStorage.getItem("nvpn") === "/keuangan"){
            names = "rekapKlaimKesehatanManifest"
          }else if (localStorage.getItem("nvpn") === "/FinancialControl"){
            names = "rekapKlaimKesehatanManifestFC"
          }else if (localStorage.getItem("nvpn") === "/direktur"){
            names = "rekapKlaimKesehatanManifestDir"
          }else if (localStorage.getItem("nvpn") === "/hrd"){
            names = "rekapKlaimKesehatanManifest-hrd";
          }
        } else if(val.no_manifest.includes('RLKPD')){
          if (localStorage.getItem("nvpn") === "/hrd"){
            names = "rekapLKPDManifest"
          }else if (localStorage.getItem("nvpn") === "/FinancialControl"){
            names = "rekapLKPDManifestFC"
          }else if (localStorage.getItem("nvpn") === "/direktur"){
            names = "rekapLKPDManifestDir"
          }
        } else if (val.rest_api === "klaim_traveloka") {
          if (newtab) {
            const route = this.$router.resolve({
              name: "travelokaklaimManifest",
              params: { id: val.id_manifest },
            });
            window.open(route.href, "_blank");
          } else {
            this.$router.push({
              name: 'travelokaklaimManifest',
              params: { id: val.id_manifest },
            });
          }
        }

        this.$router.push({
          name: names,
          params: { id: val.id_manifest },
        });
      }
    },

    // Identik dengan handleView diatas
    handleNotification(value) {
      Event.$emit("trigHideMegaMenu", true);
      const rest = value.rest_api.toLowerCase();
      const aksi = value.aksi.toLowerCase();

      if (rest === "sppds" || rest ==='sppds/sppdsdetil') {
        this.$router
          .push({ name: "manifest", params: { id: value.id_manifest } })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "um_pd") {
        this.$router
          .push({
            name: "umpd_manifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "um_pp") {
        this.$router
          .push({
            name: "UmppManifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "suplier") {
        this.$router
          .push({
            name: "manifestPurchasing",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "pp") {
        this.$router
          .push({
            name: "manifestPp",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "list_pp") {
        this.$router
          .push({
            name: "pp",
            params: { },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "lap_um_pp") {
        this.$router
          .push({
            name: "lapUmppManifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "po") {
        this.$router
          .push({
            name: "PoManifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "wo") {
        this.$router
          .push({
            name: "manifestWO",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "sales_notification") {
        this.$router.push({
          name: "manifestSalesNotification",
          params: { id: value.id_manifest, tlc: value.tlc },
        });
      } else if (rest === "lap_um_pd") {
        this.$router
          .push({
            name: "manifestLaporanUmpd",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "klaim_biaya_pd") {
        this.$router
          .push({
            name: "manifestKlaimPd",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "kas_kecil") {
        this.$router
          .push({
            name: "manifestLaporanKasKecil",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "kas_kecil_el") {
        this.$router
          .push({
            name: "manifestLaporanKasKecilElektronik",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "lap_kegiatan_pd") {
        this.$router
          .push({
            name: "manifestLapPD",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "um_pd/umpddetil") {
        if (aksi === "revised") {
          this.$router
            .push({
              name: "umpd_edit",
              params: { id: value.id_manifest, tlc: value.tlc },
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else if (rest === "pp/pi") {
        this.$router
          .push({
            name: "PiManifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "create_pp-pi") {
        this.$router
          .push({
            name: "CreatePiFromlink",
            params: { id: value.id_manifest},
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "klaim_biaya_pp") {
        this.$router
          .push({
            name: "manifestKlaimPp",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "addendum") {
        this.$router
          .push({
            name: "AddendumManifest",
            params: { id: value.id_manifest, tlc: value.tlc },
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (rest === "bkkreleaseklaimpp") {
        this.$router.push({
          name: "BkkReleaseKlaimPP",
        });
      } else if (rest === "bkkreleaseklaimpd") {
        this.$router.push({
          name: "BkkRelease",
        });
      } else if (rest === "bkkreleaseklaimdirektur") {
        this.$router.push({
          name: "BkkReleaseKlaimdirektur",
        });
      } else if (rest === "bkkreleaseklaimcc") {
        this.$router.push({
          name: "BkkReleaseKlaimCC",
        });
      } else if (rest === "bkkreleasepi") {
        this.$router.push({
          name: "BkkReleasePI",
        });
      } else if (rest === "bkkreleaseumpp") {
        this.$router.push({
          name: "BkkReleaseUmpp",
        });
      } else if (rest === "bkkreleaseumpd") {
        this.$router.push({
          name: "BkkReleaseUmpd",
        });
      } else if (rest === "bkkrelease") {
        this.$router.push({
          name: "BkkRelease",
        });
      } else if (rest === "klaim_direktur") {
        this.$router.push({
          name: "manifestDirectur",
          params: { id: value.id_manifest, tlc: value.tlc },
        });
      } else if (rest === "sales_contract") {
        this.$router.push({
          name: "manifestSalesContract",
          params: { id: value.id_manifest },
        });
      } else if (rest === "otherincome") {
        this.$router.push({
          name: "OtherIncomeManifestKeu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "otheroutcome") {
        this.$router.push({
          name: "OtherOutcomeManifestKeu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "financing") {
        this.$router.push({
          name: "financing-manifest",
          params: { id: value.id_manifest },
        });
      } else if (rest === "account_mutation") {
        this.$router.push({
          name: "AccountMutationManifestKeu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "payment_schedule") {
        this.$router.push({
          name: "PaymentScheduleManifestKeu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "penarikan-financing") {
        this.$router.push({
          name: "penarikan-financing-manifest",
          params: { id: value.id_manifest },
        });
      } else if (rest === "bidbond_request") {
        if ("Vice President Marketing".toLowerCase()==
          (value.sebagai ? value.sebagai.toLowerCase() : '')){
            this.$router.push({
              name: "bidBondRequest-manifest",
              params: { id: value.id_manifest },
            });
        }else{
          this.$router.push({
            name: "bidBondRequest-manifest-mar",
            params: { id: value.id_manifest },
          });
        }
      } else if (rest === "bidbond") {
        this.$router.push({
          name: "bidBond-manifestKeu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "piutang_karyawan") {
        this.$router.push({
          name: "piutangkaryawan-manifest-keu",
          params: { id: value.id_manifest },
        });
      } else if (rest === "pembayaran_piutang") {
        this.$router.push({
          name: "pembayaranpiutang-manifest-hrd",
          params: { id: value.id_manifest },
        });
      } else if (rest === "evaluasi_suplier") {
        this.$router.push({
          name: "supplierEvaluation-manifest",
          params: { id: value.id_manifest },
        });
      } else if (rest === "close_um") {
          this.$router.push({
            name: "closingUMManifestKeu",
            params: { id: value.id_manifest },
          });
      } else if (rest === "account_pay") {
        this.$router.push({
          name: "account-pay-manifest",
          params: { id: value.id_manifest, tlc: value.tlc },
        });
      } else if (rest.toLowerCase() === "invoice") {
        this.$router.push({
          name: "invoice-manifest",
          params: { id: value.id_manifest, tlc: value.tlc },
        });
      } else if (rest === "account_receivable") {
        if ("Keuangan".toLowerCase() ==
          (value.sebagai ? value.sebagai.toLowerCase() : '')) {
            this.$router.push({
              name: "account-receive-manifest",
              params: { tab: 'manifest', jns: "penerimaan_kontrak", id: value.id_manifest },
            });
        } else {
          this.$router.push({
            name: "account-receivable-manifest",
            params: { tab: 'manifest', jns: "penerimaan_kontrak", id: value.id_manifest },
          });
        }
      } else if (rest === "spt") {
        this.$router.push({
          name: "SPTManifest",
          params: { id: value.id_manifest, tipe: CryptoJS.AES.encrypt(value.tipe,"IAO-key").toString() },
        });
      } else if (rest === "list_bank_guarantee") {
        this.$router.push({
          name: "bankguarantee-create",
          params: {props_invoice_no: value.invoice_no},
        });
      }else if(rest === "pp/pirelease"){
        this.$router.push({
          name: "ManifestPIRelease",
          params: {id: value.id_manifest},
        });
      } else if(rest === "rnd_notification"){
        this.$router.push({
          name: "manifestRNDNotification",
          params: {id: value.id_manifest},
        });
      } else if(rest === "project"){
        this.$router.push({
          name: "viewproyekrab.manifestrabAcc",
          params: {id: value.id_manifest, rabview: false},
        });
      } else if (rest === "/simfoni/plafon/annual" || value.rest_api === "/simfoni/plafon/monthly") {
        this.$router.push({
          name: value.sebagai=="Direktorat Finance" ? "MonthlyAnnualManifest_Vpf" : "MonthlyAnnualManifestDir",
          params: {
            id: value.id_manifest, 
            type: rest === "/simfoni/plafon/annual" ? "1" : 
            (rest === "/simfoni/plafon/monthly" && !value.tipe.includes("Liability") ? "2" : "3") },
        });
      } else if (rest === "klaim_cc") {
        this.$router.push({
          name: 'manifestKlaimCC',
          params: { id: value.id_manifest },
        });
      } else if (rest === "klaim_cc_pp") {
        this.$router.push({
          name: 'manifestKlaimCCPp',
          params: { id: value.id_manifest },
        });
      } else if (rest === "klaim_cc_pd") {
        this.$router.push({
          name: 'manifestCCKlaimPd',
          params: { id: value.id_manifest },
        });
      } else if (rest === "lap_bailout") {
        this.$router.push({
          name: 'bailoutfundreportManifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "pipeline") {
        this.$router.push({
          name: 'pipeline-manifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "prospek") {
        this.$router.push({
          name: 'manifestProspectNotification',
          params: { id: value.id_manifest },
        });
      } else if (rest === "rekap_kesehatan") {
        this.$router.push({
          name: 'rekapKlaimKesehatanManifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "rekap_lkpd") {
        this.$router.push({
          name: 'rekapLKPDManifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "komponen_gaji") {
        this.$router.push({
          name: value.sebagai=='User' ? 
            'salary-component-manifest-hrd' 
            : 'salary-component-manifest-dir',
          params: { id: value.id_manifest },
        });
      } else if (rest === "pp/recapitulationrelease") {
        this.$router.push({
          name: 'ManifestRecapitulationRelease',
          params: { id: value.id_manifest },
        });
      } else if (rest === "ukk") {
        this.$router.push({
          name: 'bkkManifestKeu',
          params: { id: value.id_manifest },
        });
      } else if (rest.includes(";")) {
        const arr = rest.split(";");

        if (arr[0] === "budget") {
          this.$router.push({
            name: 'anggaran.manifestAcc',
            params: { 
              id: value.id_manifest, 
              budget_thn: arr[1], 
              rabview: false, 
              status:  arr[3]
            },
          });
        }
      } else if (rest === "revisi_budget") {
        this.$router.push({
          name: 'anggaran.manifest.draft',
          params: { id: value.id_manifest },
        });
      } else if (rest === "rekap_tiket") {
        this.$router.push({
          name: 'rekapKlaimTiketManifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "klaim_cc_tiket") {
        this.$router.push({
          name: 'manifest_klaim_tiket',
          params: { id: value.id_manifest },
        });
      } else if (rest === "kewajiban") {
        this.$router.push({
          name: 'kewajiban_manifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "liability") {
        this.$router.push({
          name: 'manifestAccountpaymonitoringFC',
          params: { id: value.id_manifest },
        });
      } else if (rest === "ap_kewajiban") {
        this.$router.push({
          name: 'ap_kewajiban_manifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "rencana_belanja") {
        this.$router.push({
          name: 'expenditurePlanManifest',
          params: { id: value.id_manifest },
        });
      } else if (rest === "klaim_traveloka") {
        this.$router.push({
          name: 'travelokaklaimManifest',
          params: { id: value.id_manifest },
        });
      }
      
      Event.$emit("notificationToggle"); // close notif
    },

    handleManifestMonitoring(page, item) {
      let data = {};
      let manifestPage = "";
      if (page === "Keuangan") {
        data = _.filter(
          this.getNavigation,
          (nav) =>
            nav.label_menu.toLowerCase().indexOf("Keuangan".toLowerCase()) >=
            0 ||
            nav.label_menu
              .toLowerCase()
              .indexOf("PIC Kas Kecil".toLowerCase()) >= 0
        );

        if (data[0].link_menu === "/keuangan") {
          manifestPage = "SpclPPManifestKeu";
        } else if (data[0].link_menu === "/pimpro") {
          manifestPage = "SpclPPManifestPimpro";
        } else if (data[0].link_menu === "/atasanLangsung") {
          manifestPage = "SpclPPManifestAL";
        } else if (data[0].link_menu === "/purchasing") {
          manifestPage = "SpclPPManifest_purchase";
        } else if (data[0].link_menu === "/direktur") {
          manifestPage = "SpclPPManifestDir";
        } else {
          manifestPage = "SpclPPManifest_";
        }
      }

      this.$router.push({
        name: manifestPage,
        params: { id: item.id },
      });
    },

    handlePDF(file) {
      window.open(URL.createObjectURL(file));
    }
  },
};
